import { z } from "zod";

import { PantryCategorySchema, PantryUnitSchema } from "./pantry";

export const ShoppingSourceSchema = z.enum(["manual", "recipe", "pantry-empty"]);
export type ShoppingSource = z.infer<typeof ShoppingSourceSchema>;

export const ShoppingItemSchema = z.object({
  id: z.string(),
  name: z.string(),
  quantity: z.number().nullable(),
  unit: PantryUnitSchema.nullable(),
  category: PantryCategorySchema.nullable(),
  source: ShoppingSourceSchema,
  completed: z.boolean(),
  completedAt: z.number().int().nullable(),
  createdAt: z.number().int(),
  updatedAt: z.number().int(),
});
export type ShoppingItemView = z.infer<typeof ShoppingItemSchema>;

export const ShoppingCreateSchema = z.object({
  name: z.string().trim().min(1).max(200),
  quantity: z.number().min(0).max(10000).nullable().optional(),
  unit: PantryUnitSchema.nullable().optional(),
  category: PantryCategorySchema.nullable().optional(),
  source: ShoppingSourceSchema.optional(),
});
export type ShoppingCreate = z.infer<typeof ShoppingCreateSchema>;

export const ShoppingBulkCreateSchema = z.object({
  items: z.array(ShoppingCreateSchema).min(1).max(40),
});
export type ShoppingBulkCreate = z.infer<typeof ShoppingBulkCreateSchema>;

export const ShoppingUpdateSchema = z.object({
  name: z.string().min(1).max(200).optional(),
  quantity: z.number().min(0).max(10000).nullable().optional(),
  unit: PantryUnitSchema.nullable().optional(),
  category: PantryCategorySchema.nullable().optional(),
  completed: z.boolean().optional(),
});
export type ShoppingUpdate = z.infer<typeof ShoppingUpdateSchema>;
